module.exports = __webpack_public_path__ + "static/media/cocktaildark.ba14a6fe.jpg";